import React from 'react';
import { Box, Typography } from '@mui/material';
import { crumbsSx, pageHeadSx, pageTitleSx, tokens } from '../../theme/tokens';

/**
 * Shared page header: crumbs + Archivo title + optional actions.
 */
export default function PageHeader({ crumbs, title, actions }) {
  return (
    <Box sx={pageHeadSx}>
      <Box>
        {crumbs && (
          <Typography sx={crumbsSx}>
            {crumbs}
          </Typography>
        )}
        <Typography component="h1" sx={pageTitleSx}>
          {title}
        </Typography>
      </Box>
      {actions && (
        <Box sx={{ display: 'flex', gap: 1.25, flexWrap: 'wrap', alignItems: 'center' }}>
          {actions}
        </Box>
      )}
    </Box>
  );
}

export function CrumbLink({ children, ...props }) {
  return (
    <Box
      component="span"
      sx={{ color: tokens.primary, cursor: 'pointer', fontWeight: 500, '&:hover': { textDecoration: 'underline' } }}
      {...props}
    >
      {children}
    </Box>
  );
}
